import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface TokenListActionsHeaderProps
  extends HeaderContext<GatewayTokenModel, unknown> {}

export const TokenListActionsHeader = (): // props: TokenListActionsHeaderProps,
ReactNode => {
  // RENDER ////////////////////////////////////////////////////////////////////

  return null;
};
